<!--
 * @Author: shuchang
 * @Date: 2022-03-10 17:37:25
 * @LastEditors: shuchang
 * @LastEditTime: 2022-05-12 16:57:43
 * @Description: 
-->
<template>
  <div class="menutree">
    <label v-for="menu in data" :key="menu.name">
      <el-submenu :index="menu.path" v-if="menu.children && menu.children.length > 0">
        <template slot="title">
            <i v-if="menu.icon" class="fa" :class="menu.icon"></i>
            <span v-if="menu.name.length < 10" class="ml8">{{menu.name}}</span>

            <el-tooltip
              class="item"
              effect="dark"
              :content="menu.name"
              placement="top-start"
              v-else
            >
              <span>{{menu.name}}</span>
            </el-tooltip>
        </template>
        <label>
          <menutree :data="menu.children"></menutree>
        </label>
      </el-submenu>
      <div v-else :to="menu.path" :key="menu.name"  @click="goTo(menu)">
        <el-menu-item :index="menu.path">
          <!-- <el-menu-item :index="index + '-'"> -->
          <i v-if="menu.icon" class="fa" :class="menu.icon"></i>
          <span v-if="menu.name.length < 10" class="ml8">{{menu.name}}</span>

          <el-tooltip class="item" effect="dark" :content="menu.name" placement="top-start" v-else>
            <span class="ml8">{{menu.name}}</span>
          </el-tooltip>

          <!-- </el-menu-item> -->
        </el-menu-item>
      </div>
    </label>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import menutree from "./menutree";
export default {
  name: "menutree",
  computed: {
    ...mapGetters(['menu'])
  },
  data() {
    return {
      menu_data: {}
    };
  },
  created() {
  },
  methods:{
    goTo(item){
      // 判断跳转的页面是否为当前页面，如果为当前页面，则不进行跳转
      // if(this.$route.path!=item.path){
         this.$store.commit("SET_PATH", item.path);
        this.$router.push({path:item.path,})
      // }
    },
  },
  components: {
    menutree: menutree
  },
  props: ["data"]
};
</script>
<style lang="scss" scoped>
  .ml8 {
    margin-left: 8px;
}

.svg-icon {
    margin-right: 0px!important;
}
</style>
